import { Divider, Flex, Image, mediaBreakpointMixin, Radio, ToggleCard } from '@zillow/constellation';
import styled from 'styled-components';
import BackgroundImage from '../../images/onboarding_background.png';

export const Left = styled(Flex)`
  width: 60%;
`;

export const Right = styled(Flex)`
  width: 40%;
`;

export const StyledDivider = styled(Divider)`
  // counter the padding in the Form
  margin-left: -16px;
  margin-right: -16px;
`;

export const StyledToggleCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media ${mediaBreakpointMixin('lg_gte')} {
    flex-direction: row;
    gap: 8px;
  }
`;

export const StyledToggleCard = styled(ToggleCard)`
  position: relative;
  flex: 1;
  border-radius: 8px;
  padding-top: 24px;
  padding-bottom: 24px;
  width: 100%;

  @media ${mediaBreakpointMixin('lg_gte')} {
    padding-top: 32px;
    padding-bottom: 32px;
    width: 246px;
  }
`;

export const StyledRadio = styled(Radio)`
  position: absolute !important;
  top: 8px;
  right: 8px;
`;

export const StyledBackground = styled.div`
  background-image: url(${BackgroundImage});
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledUpsellImage = styled(Image)`
  width: max(80%, 500px);
  height: auto;
`;
